var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDownWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1998 0H5.81977C2.17977 0 0.00976562 2.17 0.00976562 5.81V14.18C0.00976562 17.83 2.17977 20 5.81977 20H14.1898C17.8298 20 19.9998 17.83 19.9998 14.19V5.81C20.0098 2.17 17.8398 0 14.1998 0ZM14.0698 9.17L10.5398 12.7C10.3898 12.85 10.1998 12.92 10.0098 12.92C9.81977 12.92 9.62977 12.85 9.47977 12.7L5.94977 9.17C5.65977 8.88 5.65977 8.4 5.94977 8.11C6.23977 7.82 6.71977 7.82 7.00977 8.11L10.0098 11.11L13.0098 8.11C13.2998 7.82 13.7798 7.82 14.0698 8.11C14.3598 8.4 14.3598 8.87 14.0698 9.17Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownWhite);
export default __webpack_public_path__ + "static/media/ArrowDownWhite.7ca53a3c9d7a823d9fa0462471d6cfea.svg";
export { ForwardRef as ReactComponent };